export enum Constants {
    //Transaction STatus code
    // @ts-ignore
    'SUCCESSFULLY' = '00',
    'CANCELLED' = '02',
    'REVERSED' = '99',
    'CANCELLED_INT' = '2',

    //Validation Status
    'SUCCESS_VALIDATED' = 1,
    'PENDING_VALIDATED' = 0,
    'FAILED_VALIDATED' = 2,

    /*Methods*/
    'POST' = 'post',
    'PUT' = 'put',
    'GET' = 'get',
    'DELETE' = 'delete',

    // Tracking Statuses
    'ON_BOARD' = 'On Board',
    'ARRIVED' = 'Arrived',
    'AT_FACILITY' = 'At Facility',
    'LOST' = 'Lost',
    'DELIVERY' = 'Delivery',

    //HTTP Codes
    'BAD_REQUEST' = 400,
    'UNAUTHORIZED' = 401,
    'FORBIDDEN' = 403,
    'UNPROCESSABLE' = 422,
    'NOT_FOUND' = 404,
    'SERVER_ERROR' = 500,
    'BAD_GATEWAY' = 502,
    'SERVICE_UNAVAILABLE' = 503,
    'SUCCESS' = 200,
    'CREATED_SUCCESSFULLY' = 201,

    // HTTP Messages
    'HTTP_403' = "Insufficient permissions!",
    'HTTP_401' = "Unauthorized!",
    'HTTP_422' = "Not Found!",
    'HTTP_404' = "Validation Error!",
    'HTTP_500' = "Server Error!",
    'HTTP_502' = "Bad Gateway!",
    'HTTP_503' = "Service Unavailable!",
    'HTTP_200' = "Success!",


    //Common Errors
    'SOMETHING_WENT_WRONG' = "Something went wrong, please contact admin",


    'INCENTIVE_PERCENTAGE_MODE' = "PER",
    'INCENTIVE_FLAT_MODE' = "FLAT",
    'OFF_TRAIN' = 0,
    'ON_TRAIN' = 1,


    'EXCEL' = '001',
    'PDF' = '002',
    'CSV' = '003',
    'TXT' = '004',

    'EXCEL_NAME' = 'Excel',
    'PDF_NAME' = 'PDF',
    'CSV_NAME' = 'CSV',
    'TXT_NAME' = 'TXT',

    'PERCENTAGE_NAME' = 'Percentage',
    'PERCENTAGE_SIGN' = '%',
    'AMOUNT_NAME' = 'Amount',
    'POS_NAME' = 'POS',
    'KIOSK_NAME' = 'KIOSK',
    'POS_ABBREV' = 'p',
    'SUCCESS_NAME' = 'Success',
    'SUCCESS_NAME_LOWERCASE' = 'success',
    'CASH_NAME' = 'CASH',
    'CARD_NAME' = 'CARD',
    'ZONE_NAME' = 'ZONE',
    'PENALTY_NAME' = 'PENALTY',
    'AUTOMOTORA_NAME' = 'AUTOMOTORA',
    'CANCELLED_NAME_STATUS' = 'Cancelled',
    'CANCELLED_NAME' = 'CANCELLED',
    'TOPUP_NAME' = 'TOPUP',
    'DEACTIVATE_NAME' = 'Deactivate',
    'ACTIVATE_NAME' = 'Activate',


    //REPORT STATUES
    'QUEUED' = 'queued',
    'RUNNING' = 'running',
    'COMPLETED' = 'completed',
    'FAILED' = 'failed',

    //Report parameter Types
    'SELECT_OPTIONS' = 'select',
    'TEXT_INPUT' = 'text',
    'DATE_INPUT' = 'date',
    'DATETIME_INPUT' = 'datetime-local',
    'TIME_INPUT' = 'time',

    //Report Codes
    'TICKET_TNX_SUMMARY_REPORT' = "TSR",
    'CARGO_TNX_SUMMARY_REPORT' = "CSR",
    'TOPUP_TNX_SUMMARY_REPORT' = "TOSR",
    'TNX_GENERAL_REPORT' = "TGR",
    'TNX_TO_FROM_STATION_REPORT' = "TTF",
    'TNX_INCENTIVE_REPORT' = "TIR",
    'TNX_PASSENGER_REPORT' = "TPR",
    'TNX_OPERATOR_REPORT' = "TOR",


    //TRANSACTION TYPES
    'TRAIN_CASH_PAYMENT' = "9006", //used in transaction
    'CARD_PAYMENT' = "9007", //used in transaction
    'EMPLOYEE_ID_PAYMENT' = "9008",
    'TOP_UP_CARD' = "9009", //used in transaction
    'REGISTRATION' = "9010",
    'CARGO' = "9019",
    'MOBILE_APP_TRANSACTIONS' = "9102",
    'ONLINE_CREDIT_TRANSACTIONS' = "9103",
    'ONLINE_PAYMENT' = "9104",
    'CARD_ADJUSTMENT' = "9105",

    //APPROVAL PROCESS CODES
    'OPERATOR_COLLECTIONS_APPROVAL_PROCESS' = "OCAP",
    'CANCEL_TICKET_TRANSACTION_PROCESS' = "CATTP",
    'CARD_ACCOUNT_ADJUSTMENT_PROCESS' = "CADP",

    //Approval Process Statuses
    'PENDING_STEP' = 'P',
    'ON_PROGRESS_STEP' = 'O',
    'APPROVED_STEP' = 'A',
    'REJECTED_STEP' = 'R',

    //Days Of the week
    'MONDAY' = 1,
    'TUESDAY' = 2,
    'WEDNESDAY' = 3,
    'THURSDAY' = 4,
    'FRIDAY' = 5,
    'SATURDAY' = 6,
    'SUNDAY' = 7,
    'ALL_DAYS' = '0',

    'DURATION_24_HOURS' = 24,
    'DURATION_48_HOURS' = 48,


    //Permission Actions
    'VIEW_ACTION' = 'V',
    'CREATE_ACTION' = 'C',
    'EDIT_ACTION' = 'E',
    'DELETE_ACTION' = 'D',
    'BLOCK_ACTION' = 'B',
    'UNBLOCK_ACTION' = 'U',
    'APPROVE_ACTION' = 'A',
    'CANCEL_ACTION' = 'Y',
    'EXECUTE_ACTION' = 'X',
    'SUBMIT_ACTION' = 'S',
    'ACTIVATE_ACTION' = 'T',
    'DEACTIVATE_ACTION' = 'Z',
    'ATTACH_ACTION' = 'AT',
    'DEATTACH_ACTION' = 'DEA',
    'PRINT_DOC' = 'P',
    'CONFIGURE_TRAIN' = 'CT',
    'GENERATE_SEAT_ACTION' = 'GSA',


    //Roles
    'ADMIN' = "ADM",
    'FISCAL_OFFICER' = 'FISC',
    'FISCAL_MASTER' = 'FISM',
    'FINANCE_MANAGER' = "FIN_MAN",
    'FISCAL_VALIDATOR' = "FISC_VAL",
    'REVISER_MASTER' = "REV_MAS",
    'CONDUCTOR' = "COND",
    'OPERADOR' = 'OPE',
    'REVISOR' = 'REV',
    'SERVICO_DE_TRANSPORTE' = 'STP',


    //Status
    'ACTIVE' = "A",
    'INACTIVE' = "I",
    'BLOCKED' = "B",
    'EXPIRED' = "E",


    //News Status
    'PUBLISHED' = "published",
    'CREATED' = "created",
    'UNPUBLISHED' = "unpublished",

    'TAB_1' = 'tab1',
    'TAB_2' = 'tab2',
    'TAB_3' = 'tab3',
    'TAB_4' = 'tab4',
    'TAB_5' = 'tab5',
    'TAB_6' = 'tab6',
    'TAB_7' = 'tab7',
    'TAB_8' = 'tab8',

    // Debit From
    'CHECK_ACCOUNT_BALANCE' = 'BA',
    'CHECK_DATE_EXPIRY' = 'BD',
    'CHECK_TRIP_BALANCE' = 'BT',

    // Package Usage
    'INTERNAL' = '0',
    'CUSTOMER' = '1',

    // Status
    'INACTIVE_STATUS' = '0',
    'ACTIVE_STATUS' = '1',

    // Account Usage
    'CUSTOMER_ACCOUNT' = 'C',
    'EMPLOYEE_ACCOUNT' = 'E',
    'INTERNAL_ACCOUNT' = 'I',
    'OPERATOR_ACCOUNT' = 'O',
    'EXTERNAL_ACCOUNT' = 'X',

    // Customer types
    'L0Z0E3' = '10',
    'GOVMT' = '19',
    'L0Z0N0' = '20',
    'L0Z1N3' = '21',
    'L0Z2N3' = '22',
    'L0Z3N3' = '23',
    'L1Z0N2' = '24',

    // Identification Types
    'EMPLOYEE_CARD' = '1',
    'NORMAL_CARD' = '2',

    // GENDERS
    'MALE' = 1,
    'FEMALE' = 2,


    //NUMBER CONSTANTS
    'ACTIVE_NUMBER' = 1,
    'INACTIVE_NUMBER' = 2,

    'FIRST_GROUP' = 1,
    'SECOND_GROUP' = 2,

    'TRUE_FIRST_CLASS_SELECT' = 1,
    'TRUE_SECOND_CLASS_SELECT' = 2,
    'TRUE_THIRD_CLASS_SELECT' = 2,
    'FALSE_CLASS_SELECT' = 0,

    'ZERO_VALUE' = 0,
    'ONE_VALUE' = 1,
    'TWO_VALUE' = 2,
    'THREE_VALUE' = 3,
    'FOUR_VALUE' = 4,
    'FIVE_VALUE' = 5,


    'ZERO_VALUE_STRING' = '0',
    'ONE_VALUE_STRING' = '1',
    'TWO_VALUE_STRING' = '2',
    'THREE_VALUE_STRING' = '3',
    'FOUR_VALUE_STRING' = '4',
    'FIVE_VALUE_STRING' = '5',


    //ALPHABET
    'A_VALUE' = 'A',
    'B_VALUE' = 'B',
    'I_VALUE' = 'I',

    'UNKNOWN' = 'UNKNOWN',

    // Device Types
    'DEVICE_KIOSK' = 'K',
    'DEVICE_POS' = 'P',

    'ZERO_STRING' = '0',
    'ONE_STRING' = '1',

    'NORMAL_1' = '1',
    'ZONAL_2' = '2',
    'AUTOMOTRA_3' = '3',
    'CARGO_4' = '4',


    'INTERNAL_ACCOUNT_USAGE' = 'I',
    'CUSTOMER_ACCOUNT_USAGE' = 'C',
    'OPERATOR_ACCOUNT_USAGE' = 'O',


    'DECLARED_COLLECTION_STATUS' = 'S',
    'APPROVED_COLLECTION_STATUS' = 'A',
    'PENDING_COLLECTION_STATUS' = 'P',
    'REJECTED_COLLECTION_STATUS' = 'R',
    'APPROVED_COLLECTION_TOP_UP' = 'TP',

    'APPROVED_AND_FINISHED' = 'AF',
    'CANCEL_AND_FINISH' = 'CF',
    'REJECTED_AND_RETURNED' = 'RR',


    'ZONAL_PRICE_TAB' = 'zonal_price_tab',
    'AUTOMOTORA_PRICE_TAB' = 'automotora_price_tab',
    'NORMAL_PRICE_TAB' = 'normal_price_tab',


    'CREDIT_CHAR' = 'C',
    'DEBIT_CHAR' = 'D',


    'LONG_TRAIN_PRICE_TAB' = 'long_train_price_tab',
}

